import React, { useState } from "react";
import SignaturePad from 'signature_pad/dist/signature_pad.js';
// reactstrap components
import {
    FormGroup,
    Label,
    Button,
    Input,
    Container,
    Row,
    Col,
    Modal,
    ModalBody,
} from "reactstrap";
import Datetime from 'react-datetime';
// core components
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import TSUpload from "components/Forms/TSUpload2.js";
import TSText from "components/Forms/TSText.js";



const SignPad = (props) => {

    
    const liff = window.liff;
    liff.init({
        liffId: '1654063801-BzZXlvV2'
    })
        .then(() => {

            if (liff.isLoggedIn()) {

                liff.getProfile().then(function (profile) {
/*
                    authenticationService.login(profile.userId, profile.userId)
                        .then(
                            user => {
                                //const { from } = this.props.location.state || { from: { pathname: "/home" } };
                                //this.props.history.push(from);
                                //window.alert(user)
                            },
                            error => {
                                console.log(error);
                            }
                        );
*/
                }).catch(function (error) {
                    window.alert('Error getting profile: ' + error);
                });

            }
        })
        .catch((err) => {

        });

    const [errMsg, setErrMsg] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [clientWidth, setClientWidth] = useState(0);
    var canvas = null;
    var signaturePad = null;
    React.useEffect(() => {

        canvas = document.getElementById("signature-pad");

        signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
        });

        setClientWidth(window.innerWidth);

    });


    const handleClear = () => {
        signaturePad.clear();
    }

    const handleSubmit = () => {
        setModal2(true);
    }
    const handleConfirm = () => {

        var dataURL = canvas.toDataURL();
        console.log(dataURL)

        /*
        const reqOpt = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            body: JSON.stringify({
                "teleID": result.data.teleID,
                "fileName": e.fileName,
                "fileCategoryID": 0,
                "fileType": e.fileType,
                "fileSize": e.fileSize,
                "fileBase64": e.fileBase64,
            })
        };

        fetch('/api/v1/tele/upload', reqOpt)
            .then(handleResponse)
            .then(
                (result) => {
                    //console.log(result);
                    //alert(result.data.fileID)
                    if (index == (totalFile - 1)) {
                        if (liff.isInClient()) {

                            liff.sendMessages([{
                                'type': 'text',
                                'text': '#ยืนยันการจอง'
                            }]).then(function () {
                                liff.closeWindow();
                            }).catch(function (error) {
                                window.alert('Error sending message: ' + error);
                            });


                        } else {
                            const { from } = props.location.state || { from: { pathname: "/home" } };
                            props.history.push(from);
                        }
                    }
                },
                (error) => {
                    console.log(error);
                    alert(error)
                }
            )
        */
        
    }


    return (
        <>
            <p className="description text-center">กรุณาลงลายมือชื่อเพื่อยอมรับข้อตกลง</p>
            <Row>
                <Col className="ml-auto mr-auto" lg="12" md="12">
                    <Button
                        block
                        className="btn-round"
                        color="info"

                        size="lg"
                        style={{ fontSize: '1.2em' }}
                        onClick={handleConfirm}
                    >
                        บันทึก
                       </Button>
                    <div style={{ border: 'solid black 1px' }} >
                        <canvas id="signature-pad" className="signature-pad" width={clientWidth} height={250}></canvas>
                    </div>
                    <Button
                        block
                        className="btn-round"
                        color="warning"
                        size="lg"
                        style={{ fontSize: '1.2em' }}
                        onClick={handleClear}
                    >
                        เซ็นใหม่
                                  </Button>
                       

                </Col>
            </Row>
        </>
    );
}

export default SignPad;
